import { render, staticRenderFns } from "./NormalSearchNav321.vue?vue&type=template&id=23212f2a&scoped=true"
import script from "./NormalSearchNav321.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav321.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23212f2a",
  null
  
)

export default component.exports